import styled from "styled-components"

export const DailyProgressSkeletonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: var(--spacing_xxl, 32px);
  padding: 16px 0;
  z-index: 1;
  position: relative;
`

export const SkeletonNutritionItem = styled.div`
  height: 22px;
  border-radius: var(--spacing_xxs, 4px);
  background: linear-gradient(270deg, #3d3d4d 0%, #555571 100%);
  width: 100%;
`

export const LeftCaloriesSkelton = styled.div`
  border-radius: 9999px;
  background: linear-gradient(270deg, #3d3d4d 0%, #555571 100%);
  width: 140px;
  height: 140px;
  flex-shrink: 0;
`
